<ifr-page-title pageTitle="'PROJECTTIME_APPROVAL_PAGE_TITLE' | translate "/>
<section id="project-time-approval-widget" iflx-widget-grid-directive options="vm.jarvisOptions">
  <project-time-approval
    open-recording-screen-for-person="vm.openRecordingScreenForPerson"
  />
  <iflx-scroll-up-directive></iflx-scroll-up-directive>
</section>
